module.exports = __webpack_public_path__ + "img/fullrate.549b6454.svg";